import React from 'react';
import { AppProvider } from './context/AppContext';
import Header from './components/Header';
import Hero from './components/Hero';
import MapDivider from './components/MapDivider';
import FeaturedKits from './components/FeaturedKits';
import Checklist from './components/Checklist';
import Reviews from './components/Reviews';
import FaqShipping from './components/FaqShipping';
import Footer from './components/Footer';
import CartDrawer from './components/Cart/CartDrawer';
import SearchOverlay from './components/Search/SearchOverlay';
import Toast from './components/Notifications/Toast';

function App() {
  return (
    <AppProvider>
      <div className="min-h-screen relative">
        <Header />
        <main>
          <Hero />
          <MapDivider />
          <FeaturedKits />
          <MapDivider />
          <Checklist />
          <Reviews />
          <FaqShipping />
        </main>
        <Footer />
        
        {/* Overlays */}
        <CartDrawer />
        <SearchOverlay />
        <Toast />
      </div>
    </AppProvider>
  );
}

export default App;